export class NewsAPI {
  constructor(Client) {
    this.Client = Client;
  }

  all = () => {
    return this.Client.get('/news').then(response => {
      if (!response || !response.data) return false;
      return response.data;
    });
  };

  single = id => {
    return this.Client.get(`/news/${id}`).then(response => {
      if (!response || !response.data) return false;
      return response.data;
    });
  };
}

export default NewsAPI;
